import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UrlShortenerForm from './components/UrlShortenerForm';
import RedirectPage from './components/RedirectPage';
import NotFound from './components/NotFound'; // You'll need to create this component

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          {/* Home page with URL shortener form */}
          <Route path="/" element={<UrlShortenerForm />} />
          
          {/* Route for handling short URLs */}
          <Route path="/:shortCode" element={<RedirectPage />} />
          
          {/* Catch all route for 404 errors */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
